module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/nav"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em",
      "padding-top": "2em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section1",
      "id": "R_sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION 1: SPIRITUAL LEADERSHIP")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1",
      "id": "R_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 1: LEAD LIKE A SHEPHERD")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2",
      "id": "R_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2: AM I QUALIFIED?")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3",
      "id": "R_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: NO ONE SAID IT WOULD BE EASY")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4",
      "id": "R_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: THE ORIGINAL PETER PRINCIPLES")])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em",
      "padding-top": "2em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section2",
      "id": "R_sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION 2: THINK LIKE A SHEPHERD")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5",
      "id": "R_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5: IT’S ALL ABOUT THE SHEEP")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6",
      "id": "R_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6: WILLING TO BE MISUNDERSTOOD")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7",
      "id": "R_ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: ADAPTING TO WEAKNESS")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8",
      "id": "R_ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8: ADAPTING TO BLIND SPOTS")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9",
      "id": "R_ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9: ADAPTING TO FEAR")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10",
      "id": "R_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10: PURSUING THE STRAGGLER")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11",
      "id": "R_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11: FLOCK FOCUSED")])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em",
      "padding-top": "2em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section3",
      "id": "R_sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION 3: SERVE WITH ENTHUSIASM")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12",
      "id": "R_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12: PRIVILEGED TO SERVE")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13",
      "id": "R_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13: THE NO COMPLAINING RULE")])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em",
      "padding-top": "2em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section4",
      "id": "R_sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION 4: LEAD BY EXAMPLE")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14",
      "id": "R_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14: SERVANT LEADERS")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15",
      "id": "R_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15: SHEPHERDS AND COWBOYS")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16",
      "id": "R_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16: WHAT WE ARE IS WHAT WE’LL GET")])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "1em",
      "padding-top": "2em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section5",
      "id": "R_sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SECTION 5: TAKE THE LONG VIEW")]), _vm._v(" "), _c('ol', {
    staticClass: "none"
  }, [_c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em",
      "margin-top": "1em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17",
      "id": "R_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17: PATIENCE")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "1.5em"
    },
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18",
      "id": "R_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18: WAITING IN THE WINGS")])])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "0em",
      "padding-top": "2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_epilogue",
      "id": "R_epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: FINAL THOUGHTS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_acknowledgments",
      "id": "R_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_notes",
      "id": "R_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_abouttheauthor",
      "id": "R_abt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": ""
    }
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780718096427_cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "chapter",
      "href": "#/text/9780718096427_chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 1: LEAD LIKE A SHEPHERD")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "page-list",
      "hidden": "hidden",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_frontmatter#page_i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_frontmatter#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_frontmatter#page_iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_frontmatter#page_iv",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iv")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_title#page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_copyright#page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("viii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_dedication#page_ix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ix")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_frontmatter1#page_x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section1#page_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section1#page_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1#page_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1#page_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1#page_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1#page_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter1#page_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter2#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter3#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter4#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section2#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section2#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter5#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter6#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter7#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter8#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter9#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter10#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter11#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section3#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section3#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter12#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter13#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section4#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section4#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter14#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter15#page_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter16#page_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section5#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_section5#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter17#page_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18#page_160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18#page_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_chapter18#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_epilogue#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_epilogue#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_media#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_media#page_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_acknowledgments#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_acknowledgments#page_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_notes#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_notes#page_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_notes#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_notes#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_abouttheauthor#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_abouttheauthor#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_backmatter#page_177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_backmatter#page_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_backmatter#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780718096427_backmatter#page_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ebf9b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/nav.vue
// module id = 75
// module chunks = 0